import { Typography, useTheme } from '@mui/material';

import { CardImage, Overlay, TextWrapper, Wrapper } from './styles';

export type CardProps = {
	image?: string;
	itemsNumber?: number;
	name: string;
	onClick?: () => void;
	nameFontSize?: number;
	className?: string;
};

export const Card = (props: CardProps) => {
	const theme = useTheme();

	const { image, itemsNumber, name, onClick, nameFontSize } = props;

	return (
		<Wrapper className={props.className} onClick={onClick}>
			{image && (
				<CardImage
					src={image}
					alt={`${name} jigsaw puzzles`}
					loading='lazy'
					decoding='async'
					width={234}
					height={234}
				/>
			)}
			<Overlay />
			<TextWrapper>
				<Typography
					fontSize={nameFontSize ? nameFontSize : 20}
					fontWeight={700}
					color={image ? theme.colors.background : theme.colors.text}
				>
					{name}
				</Typography>
				<Typography fontSize={14} fontWeight={400} color={image ? theme.colors.background : theme.colors.text}>
					{itemsNumber ?? 0} items
				</Typography>
			</TextWrapper>
		</Wrapper>
	);
};
